import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconAdd: FC<ComponentProps<typeof IconWrapper>> = (props) => {
  const { size = 16, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 2.55389C8.3015 2.55389 8.54596 2.79835 8.54596 3.09989V7.45389H12.9C13.2015 7.45389 13.446 7.69835 13.446 7.99989C13.446 8.30144 13.2015 8.54589 12.9 8.54589H8.54596V12.8999C8.54596 13.2014 8.3015 13.4459 7.99996 13.4459C7.69841 13.4459 7.45396 13.2014 7.45396 12.8999V8.54589H3.09996C2.79841 8.54589 2.55396 8.30144 2.55396 7.99989C2.55396 7.69835 2.79841 7.45389 3.09996 7.45389H7.45396V3.09989C7.45396 2.79835 7.69841 2.55389 7.99996 2.55389Z" fill={color}/>
      </svg>
    </IconWrapper>
  )
}
